import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SearchOff as SearchOffIcon } from "@mui/icons-material";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        gap: 2,
      }}
    >
      <SearchOffIcon sx={{ fontSize: 80, color: "text.secondary" }} />
      <Typography variant="h4" color="text.primary">
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
        The page you're looking for doesn't exist or you don't have permission to access it.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={() => navigate("/")}>
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
